export const setupInlineManual = (inlineUrl : string) : void => {
  if(!inlineUrl || inlineUrl === '')
    return;

  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  script.onload = function() : void {
    setupInlineStyle();
  };

  script.src = inlineUrl;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const setupInlineStyle = () : void => {
  setupClassName();
  setupOpenedPanel();
  replaceButtonText();
  document.querySelectorAll('.inline-manual-player-custom-styles').forEach(e => e.remove());
};

const setupClassName = () : void => {
  const div = document.getElementsByClassName('inmplayer-general')[0];
  if(!div)
    return;

  div.className = 'biobar-inmplayer';
  div.addEventListener('click', setupInlineStyle);

  const trigger = document.getElementsByClassName('inmplayer-trigger')[0];
  if(!trigger)
    return;

  trigger.className = 'biobar-inmplayer-trigger';
};

const setupOpenedPanel = () : void => {
  try {
    const searchDiv = document.getElementsByClassName('inmplayer-panel-search')[0];
    if(!searchDiv)
      return;

    (searchDiv.children[0] as HTMLInputElement).placeholder = 'Como podemos te ajudar?';

    const icon = document.createElement('span');
    icon.className = 'material-icons';
    icon.innerHTML = 'search';

    const button = searchDiv.children[1];

    button.innerHTML = '';
    button.append(icon);
  } catch (e) {
    console.log('[Biobar] Failed to configure inline style');
  }
};

const replaceButtonText = () : void => {
  const panelCustomFooter = document.getElementsByClassName('inmplayer-panel-custom-footer')[0];
  if(!panelCustomFooter)
    return;

  if(!panelCustomFooter.children[0]) {
    const panelFooter = document.getElementsByClassName('inmplayer-panel-footer')[0];
    panelFooter.innerHTML = '';
    return;
  }

  (panelCustomFooter.children[0] as HTMLAnchorElement).text = 'Abrir chamado';
};